import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              最新快讯
            </h2>
            <p className="text-sm text-foreground-500 mt-2">实时追踪，分钟级更新</p>
          </div>
          <div className="flex items-center gap-2 text-xs text-foreground-400">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
            实时更新中
          </div>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300/60 hidden sm:block"></div>

          <div className="space-y-0">
            {updateItems.map((item, idx) => (
              <div
                key={item.id}
                className="relative flex items-start gap-4 sm:gap-6 py-3.5 group"
              >
                <div className="hidden sm:flex w-10 h-10 flex-shrink-0 items-center justify-center rounded-full bg-background-50 border-2 border-background-300/60 group-hover:border-primary-400 transition-colors z-10">
                  {idx === 0 ? (
                    <i className="ri-flashlight-line text-primary-500 text-sm"></i>
                  ) : (
                    <span className="text-xs font-bold text-foreground-500">{idx + 1}</span>
                  )}
                </div>

                <div className="flex-1 min-w-0 bg-background-50 rounded-xl p-4 border border-background-200/60 group-hover:border-primary-200/60 transition-all">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className="text-xs text-foreground-400 flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-time-line"></i>
                      {item.time}
                    </span>
                    <span className={`px-1.5 py-0.5 text-[10px] font-semibold rounded whitespace-nowrap ${
                      item.tag === '最新' ? 'bg-primary-100 text-primary-600'
                      : item.tag === '爆料' ? 'bg-accent-100 text-accent-600'
                      : item.tag === '独家' ? 'bg-accent-100 text-accent-700'
                      : item.tag === '追踪' ? 'bg-secondary-100 text-secondary-600'
                      : item.tag === '热议' ? 'bg-primary-50 text-primary-500'
                      : 'bg-secondary-100 text-secondary-600'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed group-hover:text-foreground-900 transition-colors">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-8">
          <button className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 border border-background-200/60 text-foreground-600 font-medium rounded-lg hover:border-primary-300 hover:text-primary-600 transition-all cursor-pointer whitespace-nowrap text-sm">
            <i className="ri-refresh-line"></i>
            加载更多快讯
          </button>
        </div>
      </div>
    </section>
  );
}